/**
 * Service: auditTrailGrids
 */
 
 //TODO: make a service for version handleling
angular.module('acme.common.service.auditTrailGrids', [
  'acme.common.service.auditTrailConfigs',
  'acme.common.service.auditTrailVersionHandler',
  'acme.common.service.templates'
])
.service('AuditTrailGridsService', ['AuditTrailConfigsService', 'AuditTrailVersionHandlerService', 'TemplatesService', function(AuditTrailConfigsService, AuditTrailVersionHandlerService, TemplatesService) {

    return  {

      config: AuditTrailConfigsService,
      versionHandler: AuditTrailVersionHandlerService,
      type: '',
      
      init: function() {
        return true;
      },
      
      getGridValuesByType: function (updated, original, type) {
        var res = {};
        if(type === 'priceLists') {
          res.updated = (updated !== undefined) ? updated[0].prices : updated;
          res.original = (original !== undefined) ? original[0].prices : original;
        }
        if(type === 'priceList' ) {
          res.updated = (updated !== undefined) ? updated.prices : updated;
          res.original = (original !== undefined) ? original.prices : original;
        }
        if(type === 'resources' || type === 'flexPays' || type === 'prices' || type === 'values' || type === 'resourceRequests' || type === 'standard' || type === 'exceptions' || type === 'addOnsCombo') {
          res.updated = updated;
          res.original = original;
        }
        if(type === 'schedules') {
          var version = this.versionHandler.getVersion();
          if(version.auditTrail.businessEvent.indexOf('event.template.schedule.resources') !== -1) {
            res = this.processResourceRequest(updated, original);
          } else {
            res.updated = updated;
            res.original = original;
          }
        }
        
        if(type === 'addOns') {
          res.updated = (updated !== undefined) ? updated.inventoryAddOns : updated;
          res.original = (original !== undefined) ? original.inventoryAddOns : original;
        }

        if(type === 'membership') {
          res.updated = (updated !== undefined) ? updated.discounts : updated;
          res.original = (original !== undefined) ? original.discounts : original;
        }
        
        return res;
      },
      
      /**
       * Determines grid type and builds model depending
       * on its _updated and _original then add model to 
       * corresponding version property.
       *
       * @param _updated: {Object}
       * @param _original: {Object}
       * @param type: {String} 
       */
      processGridType: function (_updated, _original, type) {
        this.type = type;    

        var model, 
            handlers, 
            accessor,
            dataset = this.getGridValuesByType(_updated, _original, type),
            updated = dataset.updated,
            original = dataset.original;
            
        handlers = this.config.getCallbackHandlers(this.type);
        accessor = this.config.getAccessor(this.type);

        if(original && original.length && updated && updated.length) {
          model = this.processGridModel(updated, original, accessor, handlers);
          model.flags = this.generateFlags(true, false, false);
        } else if (updated === undefined || !updated.length && original) {
          model = this.processRemovedGridModel(original || {}, accessor || {}, handlers);
          model.flags = this.generateFlags(false, false, true);
        } else  {
          model = this.processNewGridModel(updated, accessor, handlers);
          model.flags = this.generateFlags(true, true, false);
        }
        if(model) {
          this.versionHandler.addToVersion( 'grids', this.generateGridModel(model, this.type));
        }
      },
      
      generateGridModel: function (model, type) {
        return {
          headers: this.config.getGridHeaders(type),
          updated: model.updated, 
          original: model.original,
          newValues: model.newValues,
          removed: model.removed,
          breadcrumb: this.config.getGridBreadCrumbs(type),
          flags: model.flags
        };
      },
      
      generateFlags: function (isPrevious, isNewValue, isRemoved) {
        return {
          isPrevious: isPrevious,
          isNewValue: isNewValue,
          isRemoved: isRemoved
        };
      },
      
      /**
       * Build model for a grid that contains and updated and
       * original values, compares both and builds dataset
       * in relation to the conditional it falls into.
       *
       * @param _updated:  {Object || Array}
       * @param _original: {Object || Array}
       * @param accessor:  {String} 
       * @param handlers:  {Function} 
       * @returns  {Object} 
       */
      processGridModel: function (_updated, _original, accessor, handlers) {
        var updated = _updated[accessor] || _updated,
            original = _original[accessor] || _original,
            dataset = { updated: [], original: [], newValues: [], removed: [] },
            maxLength;
            
          if(original.length > updated.length) {
            original.forEach(function (val, idx, obj) {
              dataset.original.push(handlers.row('original', val));
              if(updated[idx]) {
                dataset.updated.push(handlers.rowByCondition('original', 'replaced', val, updated[idx]));
              } else {
                dataset.updated.push(handlers.row('removed', val));
              }
            });
          }
          
          if(original.length < updated.length) {
            original.forEach(function (val, idx, obj) {
              var maxLength = original.length - 1;
              dataset.original.push(handlers.row('original', val));              
              if(maxLength === idx) {
                for(i=maxLength,ii=updated.length;i<ii;i++) {
                  if(idx === i) {
                    dataset.updated.push(handlers.rowByCondition('original', 'replaced', val, updated[idx]));
                  } else {
                    dataset.updated.push(handlers.row('replaced', updated[i]));
                  }
                }
              } else {
                dataset.updated.push(handlers.rowByCondition('original', 'replaced', val, updated[idx]));
              }
            });
          }
          
          if(original.length === updated.length) {
            original.forEach(function (val, idx, obj) {
              dataset.original.push(handlers.row('original', val));
              dataset.updated.push(handlers.rowByCondition('original', 'replaced', val, updated[idx]));
            });
          }
                            
          return dataset;        
      },
      
      /**
       * Builds model, a NEW grid, adds values to the 
       * newValues property, uses handlers fn
       * to create the dataset object.
       * @param _newValues:  {Object || Array}
       * @param accessor:  {String} 
       * @param handlers:  {Function} 
       * @returns  {Object} 
       */
      processNewGridModel: function(_newValues, accessor, handlers) {
        var obj = _newValues[accessor] || _newValues,
            dataset;
        if(obj.length) {
          dataset = { updated: [], original: [], newValues: [], removed: []};
          obj.forEach(function (val, idx, obj) {
            dataset.newValues.push(handlers.row('original', val));
          });
        } else {
          dataset = false;
        }
        return dataset;
      },
      
      /**
       * Builds model, adds value to removed property,
       * uses handlers fn to create the dataset object.
       * @param _removed:  {Object || Array}
       * @param accessor:  {String} 
       * @param handlers:  {Function} 
       * @returns  {Object} 
       */
      processRemovedGridModel: function(_removed, accessor, handlers) {
        var obj = _removed[accessor] || _removed,
            dataset;
        if(obj.length) {
          dataset = { updated: [], original: [], newValues: [], removed: []};
          obj.forEach(function (val, idx, obj) {
            dataset.removed.push(handlers.row('removed', val));
          });
        } else {
          dataset = false;
        }
        return dataset;
      },
      
      /**
       * Builds model, checks for resourceRequest, and
       * adds it to the dataset obj, and sets the correct type.
       * @param updated:  {Object}
       * @param original:  {Object} 
       * @returns  {Object} 
       */
      processResourceRequest: function (updated, original) {
        var dataset = {};
        
        updated.forEach(function (val) {
          if(TemplatesService.hasScheduleResourceRequests(val)) {
            dataset.updated = val.resourceRequests;
          }
        });
        original.forEach(function (val) {
          if(TemplatesService.hasScheduleResourceRequests(val)) {
            dataset.original = val.resourceRequests;
          }            
        });
        
        dataset.original = original.some(function (val) {return TemplatesService.hasScheduleResourceRequests(val);}) ? dataset.original : [];
        dataset.updated = updated.some(function (val) {return TemplatesService.hasScheduleResourceRequests(val);}) ? dataset.updated : [];
        this.type = 'resourceRequests';
        
        return dataset;
      }
      
    };
    
}]);